/**
 * SlideRouter — pega o slide corrente do manifest e monta o componente
 * apropriado baseado em slide.type.
 *
 * Fase 4: text. Fase 5: quiz. Fase 6: mission. Custom/video ficam pra fase
 * futura (v1.1).
 */

import type { Slide } from '../types/manifest'
import { MissionSlide } from '../components/MissionSlide'
import { Quiz } from '../components/Quiz'
import { TextSlide } from '../components/TextSlide'
import { VideoSlide } from '../components/VideoSlide'
import { resolveCustom } from '../registry/customRegistry'

interface Props {
  slide: Slide | undefined
}

export function SlideRouter({ slide }: Props) {
  if (!slide) {
    return (
      <div style={{ padding: 'var(--spacing-lab-5)', color: 'var(--color-lab-ink-3)' }}>
        <em>Slide não encontrado.</em>
      </div>
    )
  }

  switch (slide.type) {
    case 'text':
      return <TextSlide slide={slide} />
    case 'quiz':
      return <Quiz slide={slide} />
    case 'mission':
      return <MissionSlide slide={slide} />
    case 'video':
      return <VideoSlide slide={slide} />
    case 'custom': {
      const Custom = resolveCustom(slide.componentId)
      if (!Custom) {
        return (
          <div style={notImplemented}>
            componente custom não registrado: <code>{slide.componentId}</code>
          </div>
        )
      }
      return <Custom {...(slide.props ?? {})} />
    }
    default:
      return (
        <div style={notImplemented}>
          tipo desconhecido: <code>{(slide as { type: string }).type}</code>
        </div>
      )
  }
}

const notImplemented: React.CSSProperties = {
  padding: 'var(--spacing-lab-5)',
  background: 'var(--color-lab-bg-2)',
  border: '1px dashed var(--color-lab-rule)',
  borderRadius: 'var(--radius-lab)',
  color: 'var(--color-lab-ink-3)',
  fontFamily: 'var(--font-lab-sans)',
}
